import React from "react";

export const DynamicTag = ({type, children, ...rest}) => {
  const Tag = React.createElement(type, {...rest}, children )
  return Tag;
}